const US_ORIGINS = ["us.wallmek.qa.grebban.com", "www.wallmektools.com", "beta.wallmektools.com"];

export const checkForLocalePrefix = (path: string, origin = "") => {
    const appIsUS = US_ORIGINS.includes(origin) || process.env.REACT_APP_IS_US_SITE === "true";

    const hasENPrefix = !!(path?.toLowerCase() === "/en" || path?.toLowerCase().startsWith("/en/"));

    if (hasENPrefix || appIsUS) {
        return "en";
    }

    return "sv";
};

export const startsWithLocalePrefix = (url: string) => {
    const path = url.includes("http") ? url.split("//")[1].split("/")[1] : url;

    const hasENPrefix = !!(
        path?.toLowerCase() === "en" ||
        path?.toLowerCase().startsWith("en/") ||
        path?.toLowerCase().startsWith("/en")
    );
    const hasSVPrefix = !!(
        path?.toLowerCase() === "sv" ||
        path?.toLowerCase().startsWith("sv/") ||
        path?.toLowerCase().startsWith("/sv")
    );

    return hasENPrefix || hasSVPrefix ? true : false;
};
